import { Box, Container, Grid, Stack, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { m } from 'framer-motion';
import AnimatedCounter from 'src/components/custom/AnimationCounter';
import { useResponsive } from 'src/hooks/use-responsive';
import { useLocales } from 'src/locales';
import { secondaryFont } from 'src/theme/typography';

const StyledTextGradient = styled(m.h1)(({ theme }) => ({
  background: '-webkit-linear-gradient(0deg, #164732, #51B949)',
  '-webkit-background-clip': 'text',
  '-webkit-text-fill-color': 'transparent',
  textTransform: 'uppercase',
  fontSize: `35px`,
  fontFamily: secondaryFont,
}));

function VenturesView() {
  const { t } = useLocales();
  const theme = useTheme();

  const mdDown = useResponsive('down', 'md');

  const investmentSectorsConfig = [
    {
      title: t('string_050'),
      image: '/assets/images/ventures/ventures-002.png',
    },
    {
      title: t('string_051'),
      image: '/assets/images/ventures/ventures-003.png',
    },
    {
      title: t('string_052'),
      image: '/assets/images/ventures/ventures-004.png',
    },
    {
      title: t('string_053'),
      image: '/assets/images/ventures/ventures-005.png',
    },
    {
      title: t('string_054'),
      image: '/assets/images/ventures/ventures-006.png',
    },
    {
      title: t('string_055'),
      image: '/assets/images/ventures/ventures-007.png',
    },
  ];

  const ourPublicInvestmentPortfolioConfig = [
    {
      title: t('string_056'),
      image: '/assets/images/ventures/ventures-008.png',
    },
    {
      title: t('Space Hunter'),
      image: '/assets/images/ventures/ventures-009.png',
    },
    {
      title: t('string_058'),
      image: '/assets/images/ventures/ventures-010.png',
    },
  ];

  return (
    <Container>
      <Stack py={12}>
        <StyledTextGradient sx={{ fontSize: mdDown ? 20 : 25, textAlign: 'center' }}>
          {t('string_045')}
        </StyledTextGradient>

        <Box component="img" srcSet="/assets/images/ventures/ventures-001.png 2x" alt="" my={12} />

        <Typography
          fontSize={30}
          textAlign="center"
          sx={{
            '& > span': {
              color: theme.palette.primary.main,
            },
          }}
        >
          {t('string_046.1')} <span>{t('string_046.2')}</span> {t('string_046.3')}{' '}
          <span>{t('string_046.4')}</span> {t('string_046.5')} <span>{t('string_046.6')}</span>{' '}
          {t('string_046.7')}
        </Typography>
      </Stack>

      <Grid container justifyContent="center">
        <Grid item xs={12} sm={8} md={6}>
          <Stack>
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
              <AnimatedCounter
                target={120}
                sx={{
                  fontSize: mdDown ? 60 : 70,
                  fontWeight: '800',
                  color: theme.palette.primary.main,
                }}
              />
              <Typography
                sx={{
                  fontSize: mdDown ? 60 : 70,
                  fontWeight: '800',
                  color: theme.palette.primary.main,
                }}
              >
                +
              </Typography>
            </Stack>
            <Typography fontSize={20} textAlign="center">
              {t('string_047')}
            </Typography>
          </Stack>
        </Grid>

        <Grid item xs={12} sm={8} md={6}>
          <Stack>
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
              <AnimatedCounter
                target={50}
                sx={{
                  fontSize: mdDown ? 60 : 70,
                  fontWeight: '800',
                  color: theme.palette.primary.main,
                }}
              />
              <Typography
                sx={{
                  fontSize: mdDown ? 60 : 70,
                  fontWeight: '800',
                  color: theme.palette.primary.main,
                }}
              >
                M+
              </Typography>
            </Stack>
            <Typography fontSize={20} textAlign="center">
              {t('string_048')}
            </Typography>
          </Stack>
        </Grid>
      </Grid>

      <Stack pt={12}>
        <Typography fontSize={mdDown ? 40 : 50} textAlign="center" mb={6}>
          {t('string_049')}
        </Typography>

        <Grid container justifyContent="center" spacing={3}>
          {investmentSectorsConfig.map((x, i) => (
            <Grid key={i} item xs={12} sm={8} md={4}>
              <Stack
                height="100%"
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                p={4}
                sx={{ background: '#FAF9F9', border: '1px solid #E0E0E0' }}
              >
                <Typography fontSize={mdDown ? 20 : 25}>{x.title}</Typography>
                <Box component="img" srcSet={`${x.image} 2x`} alt="" width={97} />
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Stack>

      <Stack pt={12}>
        <Typography fontSize={mdDown ? 40 : 50} textAlign="center" mb={6}>
          {t('string_059')}
        </Typography>

        <Grid container justifyContent="center" spacing={3}>
          {ourPublicInvestmentPortfolioConfig.map((x, i) => (
            <Grid key={i} item xs={12} sm={8} md={4}>
              <Stack height="100%" sx={{ background: '#FAF9F9', border: '1px solid #E0E0E0' }}>
                <Box component="img" srcSet={`${x.image} 2x`} alt="" width="100%" />
                <Stack p={2}>
                  <StyledTextGradient sx={{ fontSize: mdDown ? 16 : 18 }}>
                    {x.title}
                  </StyledTextGradient>
                </Stack>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Stack>

      <StyledTextGradient sx={{ fontSize: mdDown ? 30 : 55, textAlign: 'center' }}>
        {t('string_060')}
      </StyledTextGradient>
    </Container>
  );
}

export default VenturesView;
